<template>

<div class="user-info--window">
    <div class="user-info--window-inner" >
        <div class="close-userinfowindow" @click="hideUserInfo" v-if="!signingOutMessage">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
            </svg>
        </div>

        <div v-if="isLoggedIn && !signingOutMessage && !deletingAccountNow">
            <h2>Mi cuenta</h2>
            <ul>
                <li class="userinfo-listitem userinfo-name">
                    <span class="userinfo-listitem--name">Nombre:</span> <span class="userinfo-listitem--detail">{{ userInfo.userName }}</span>
                </li>
                <li class="userinfo-listitem userinfo-email">
                    <span class="userinfo-listitem--name">Email:</span> <span class="userinfo-listitem--detail">{{ userInfo.email }}</span>
                </li>
                <li class="userinfo-listitem userinfo-availabletokens">
                    <span class="userinfo-listitem--name">Saldo de fichas:</span> <span class="userinfo-listitem--detail">{{ userInfo.availableTokens }}</span>
                </li>
            
                <li style="margin-top: 3rem;">
                    <button @click="openBuyTokens" class="button2">Comprar fichas</button>
                    <button @click="openMyCards" class="button2" style="margin-left:1rem;">Mis Cartas</button>
                </li>
                <li class="userinfo-listitem userinfo-signout">
                    <span @click="signOut">Cerrar sesión</span> <span @click="showConfirmDeleteAccount = true" style="margin-left:2rem">Eliminar Cuenta</span>
                </li>
            </ul>
            <div v-if="showConfirmDeleteAccount" class="permanent-delete--account-box">
                <h3>Atención</h3>
                <p style="margin-bottom: 1rem;">Todas las imágenes, fichas y demás elementos serán eliminados y no podrán ser recuperados en ningún momento.</p>
                <p>¿Está seguro de que desea eliminar permanentemente su cuenta?</p>
                <div class="permanent-delete--account-box--actions">
                    <div @click="showConfirmDeleteAccount = false">No</div>
                    <div @click="confirmDeleteAccount">Si</div>
                </div>
            </div>
        </div>
        <div v-if="signingOutMessage" class="sigingout-message">
            <div class="sigingout-message--icon"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25"/><path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z" class="signingout--spinner"/></svg></div>
            <div class="sigingout-message--text">cerrando sesión</div>
        </div>

        <div v-if="deletingAccountNow" class="sigingout-message">
            <div class="sigingout-message--icon"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25"/><path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z" class="signingout--spinner"/></svg></div>
            <div class="sigingout-message--text">borrando cuenta</div>
        </div>
        
    </div>
    
</div>


</template>
<script>
import axios from 'axios';
export default {
    data() {
        return {
            signingOutMessage: false,
            showConfirmDeleteAccount: false,
            deletingAccountNow: false
        }
    },
    methods: {
        confirmDeleteAccount() {
            const formData = new FormData();
            formData.append('confirm', 'yes');
            let vm = this;
            axios.post('https://www.cartafutbol.com/api/v1/User/removeAccount.php', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'Authorization': `Bearer ${this.$store.state.user.tokenId}`
                    },
                })
                .then(response => {
                    console.log('Account deleted successfully:', response.data);
                    console.log('we will refresh the page so user isnot loggid in anymore')
                    vm.deletingAccountNow = true;
                    // Remove from localStorage
                    if (localStorage.getItem("cartaFutbol__user")) {
                        localStorage.removeItem("cartaFutbol__user");
                    }

                    // Remove from sessionStorage
                    if (sessionStorage.getItem("cartaFutbol__user")) {
                        sessionStorage.removeItem("cartaFutbol__user");
                    }
                    setTimeout(()=>{
                        location.reload();
                    }, 1500)
                })
                .catch(error => {
                    console.error('Could not delete account:', error);
                });
        },
        cancelDeleteAccount() {
            this.cancelDeleteAccount = false;
        },
        hideUserInfo() {
            this.$emit('hideUserInfo')
        },
        signOut() {
            this.signingOutMessage = true;
            // Remove from localStorage
            if (localStorage.getItem("cartaFutbol__user")) {
                localStorage.removeItem("cartaFutbol__user");
            }

            // Remove from sessionStorage
            if (sessionStorage.getItem("cartaFutbol__user")) {
                sessionStorage.removeItem("cartaFutbol__user");
            }
            setTimeout(() => {
                location.reload();   
            }, 1500);
            
        },
        openBuyTokens() {
            this.hideUserInfo();
            this.$emit('openBuyTokens')
        },
        openMyCards() {
            this.hideUserInfo();
            this.$emit('openMyCards')
        }
    },

    computed: {
        userInfo() {
            if(this.$store.state.loggedIn) {
                return this.$store.state.user
            }
        },
        isLoggedIn() {
            return this.$store.state.loggedIn
        }
        // createdCards() {
        //     return this.$store.state.createdCards
        // }
    }
}
</script>
<style lang="less">

.user-info--window {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background: var(--overlay_bg);
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 1rem;
    z-index: 1000;
    overflow: auto;

    &::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        backdrop-filter: blur(10px); /* Adjust the blur radius as needed */
        z-index: -1;
    }
}

.user-info--window-inner {
    background: white;
    border: 1px solid black;
    padding: 3rem 2rem 3rem;
    width: 100%;
    max-width: 550px;
    border-radius: var(--radius_global);
    margin: auto;
    position: relative;
    box-shadow: var(--modal_boxshadow);
}

.close-userinfowindow {
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;

    svg {
        width: 2rem;
        height: auto;
    }
}

.userinfo-listitem {
    margin-top: 3rem;
    display: flex;
    align-items: baseline;

    span.userinfo-listitem--name {
        font-weight: 700;
        font-size: .85rem;
        text-transform: uppercase;
        color: #777;
        width: 180px;
        padding-right: 0.85rem;
    }

    span.userinfo-listitem--detail {
        font-weight: 700;
        font-size: .85rem;
        flex: 1;
        border-bottom: 1px solid #ececec;
        padding-bottom: 0.5rem;
    }
}

.userinfo-signout {

    span {
        text-decoration: underline;
        cursor: pointer;
        font-size: .85rem;
        margin: 2rem 0 1rem;
        font-weight: 700;

        &:hover {
            text-decoration: none;
        }
    }
}

.sigingout-message {
    text-align: center;
    font-weight: 600;
    font-size: 0.85rem;
    margin: 1rem 0;

    .sigingout-message--icon {
        text-align: center;
    }

    .sigingout-message--icon {
        text-align: center;
        margin: 1rem auto 1rem;

        svg {
            transform-origin:center;
            animation: signOutSpinner .75s infinite linear;
            height: auto;
            width: 23px;
            fill: #555;
            display: inline-block;
        }
    }
}

@keyframes signOutSpinner{
    100%{transform:rotate(360deg)}
}

h3.popup--title {
    font-weight: 300;
    font-size: 1.65rem;
    margin-bottom: 2rem;
}

.permanent-delete--account-box {
    font-size: .85rem;
    font-weight: 500;
    margin-bottom: 1rem;
    padding-top: 1rem;
    border: 1px solid #ccc;
    background: #f5f5f5;
    border-radius: 0.3rem;
    text-align: center;
    overflow: hidden;

    h3 {
        text-align: center;
        text-align: center;
        font-size: 1.2rem;
        margin-bottom: 1rem;
        font-weight: 700;
    }

    .permanent-delete--account-box--actions {
        display: flex;
        width: 100%;
        border-top: 1px solid #ccc;
        margin-top: 3rem;

        & > div {
            width: 50%;
            text-align: center;
            flex: 1;
            cursor: pointer;
            font-weight: 400;
            color: var(--blue_main);
            padding: 1rem 0.2rem;
            font-size: 1rem;

            &:hover {
                font-weight: 600;
                background: #fff;
            }

            &:first-child {
                border-right: 1px solid #ccc;
            }
        }

    }
}

// .cancelPermanentDelete {

// }

.button.confirmPermanentDelete {
    background: #ff5722;
    color: #fff;
    margin-left: 1rem;

    &:hover {
        background: black;
        color: #fff;
    }
}

</style>